import React, { useState } from "react";

function LicenseTermItem(props) {
  const [isExpanded, setIsExpanded] = useState(false);
  let expandAction = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="license-item">
      <div className="package">
        <div className="header-bar">
          <div onClick={expandAction} className="name">
            <i
              className={
                isExpanded ? "icon-omni-down-arrow" : "icon-omni-right-arrow"
              }
            />
            {props.item.packageName}
          </div>
          {props.item.packageUrl !== null && props.item.packageUrl.length > 0 && (
            <div className="url">
              <a href={props.item.packageUrl} target="_blank">
                {props._.LicenseHome}
              </a>
            </div>
          )}
        </div>
        {isExpanded && <div className="terms">{props.item.licenseTerms}</div>}
      </div>
    </div>
  );
}

export default LicenseTermItem;
